import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { UserContext } from '../../App';

const Logout = () => {
    const history = useHistory();
    const [cardDisplay, setCardDisplay, authentication, setAuthentication, snackBarUI, setSnackBarUI, backdropUI, setBackdropUI] = useContext(UserContext);
    const eraseLocalStorage = () => {
        localStorage.clear();
        setAuthentication(false);
        history.push("/");
    }
    return (
        <div className="center-admin">
            {
                localStorage.getItem('login') === "true" ? <h3 className="text-success shadow">Login credential is saved!</h3> :
                    <h3 className="text-danger shadow">Local Storage is not saved</h3>
            }
            <br /><br />
            {
                localStorage.getItem('login') === "true" ? <Button onClick={eraseLocalStorage} variant="danger">Logout</Button> :
                    <></>
            }
        </div>
    );
};

export default Logout;